import*as t from"react";import s from"classnames";import{BaseButton as p}from"./_internal/base-button.js";const o=t.forwardRef(({className:e,...n},r)=>t.createElement(p,{...n,ref:r,className:s("rt-IconButton",e)}));o.displayName="IconButton";export{o as IconButton};
//# sourceMappingURL=icon-button.js.map
